import React, { useState } from "react";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import classes from "./MobileHelpSearchModal.module.css";
import { Input } from "../../../../stories/Input/Input";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../stories/assets/Fonts";
import { CancelIconBlack } from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";

import ModalSkeletonCssClasses from "../../../ModalSkeleton/ModalSkeleton.module.css";



export default function MobileHelpSearchModal({ show, setShow, searchText, setSearchText, SearchArray, setRole }) {

  const resetAllState = () => {
    setSearchText("");
    setShow(false);
    setRole(null);
  }
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px 16px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <div className={classes.modalContent}>
          <Col md={12} className={classes?.HeaderContainer}>
            <img src={CancelIconBlack} className={classes?.closeIcon} onClick={()=>{
              resetAllState();
            }} />
            <span className={classes?.headingText} style={{ ...Fonts?.b3 }}>Search</span>
          </Col>
          <Input
            state={searchText}
            setter={setSearchText}
            placeholder={"Search Lytesnap help center"}
          />

          {SearchArray.length > 0 && searchText !== "" && (
            <Col md={12}>
              <div>
                {SearchArray.map((item, index) => (
                  <>
                    <span
                      style={{
                        ...Fonts.b3,
                        color: Colors.neutralShadesOfDimGray,
                        marginTop: index === 0 ? "24px" : "4px",
                      }}
                      className={[classes.searchDataGeneralText, classes.searchDataHeading].join(" ")}
                    >
                      {item?.title}
                    </span>
                    {item?.categories?.map((innerData) => {
                      return (
                        <span
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                          }}
                          className={[classes.searchDataGeneralText, classes.searchDataListText].join(" ")}
                          onClick={() => {
                            setRole(item?.title);
                            setSearchText(innerData?.title);
                            setShow(false);

                            // setTimeout(() => {
                            //   setSearchText(innerData?.title);
                            // }, 50);
                          }}
                        >
                          {innerData?.title}
                        </span>
                      );
                    })}
                  </>
                ))}
              </div>
            </Col>
          )}



        </div>
      </ModalSkeleton>
    </>
  );
}
